module.exports = __webpack_public_path__ + "static/media/mfi_IDCard_logo.e69f36fe.png";